/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC } from 'react'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { Label } from '@progress/kendo-react-labels'
import { SimulationCalculationInfoResItem } from '@gateway.Simulation'
export interface ExpenseInformationProps {
  workYamadumi: SimulationCalculationInfoResItem
  isReadonlyDisabled: boolean
  onChange: (id: string, value: number | null) => void
}
export const ExpenseInformationTypeA: FC<ExpenseInformationProps> = React.memo(({
  workYamadumi,
  isReadonlyDisabled,
  onChange
}) => {
  return (
    <Card>
      <CardBody>
        <GridLayout gap={{ cols: 10 }}>
          <GridLayoutItem col={1}>
            <GridLayout
              gap={{ rows: 1 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>構造比率（{workYamadumi.unit1}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>基礎</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4, useGrouping: false }}
                  value={workYamadumi.structureRatioFoundation ?? undefined}
                  onChange={
                    (event) => onChange('structureRatioFoundation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4, useGrouping: false }}
                  value={workYamadumi.structureRatioUnderground ?? undefined}
                  onChange={
                    (event) => onChange('structureRatioUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4, useGrouping: false }}
                  value={workYamadumi.structureRatioGround ?? undefined}
                  onChange={
                    (event) => onChange('structureRatioGround', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={2}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>施工数量（{workYamadumi.unit2}）</Label>
                <label style={{ color: 'gray', fontSize: 'small' }}>(=構造比率 × 延床面積)</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>全体</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4 }}
                  disabled
                  value={workYamadumi.constructionQuantityAll ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>基礎</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4 }}
                  value={workYamadumi?.constructionQuantityFoundation ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityFoundation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4 }}
                  value={workYamadumi?.constructionQuantityUnderground ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>先行床</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4 }}
                  value={workYamadumi?.constructionQuantityFloorPrecedence ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityFloorPrecedence', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={6} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={6} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 4 }}
                  value={workYamadumi?.constructionQuantityGround ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityGround', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={3}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>歩掛（{workYamadumi.unit3}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>基礎</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 2, useGrouping: false }}
                  value={workYamadumi?.productionRateFoundation ?? undefined}
                  onChange={
                    (event) => onChange('productionRateFoundation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 2, useGrouping: false }}
                  value={workYamadumi?.productionRateUnderground ?? undefined}
                  onChange={
                    (event) => onChange('productionRateUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>先行床</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 2, useGrouping: false }}
                  value={workYamadumi?.productionRateFloorPrecedence ?? undefined}
                  onChange={
                    (event) => onChange('productionRateFloorPrecedence', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 2, useGrouping: false }}
                  value={workYamadumi?.productionRateGround ?? undefined}
                  onChange={
                    (event) => onChange('productionRateGround', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={4}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>工期（ヶ月）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>基礎</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleFoundation ?? undefined}
                  onChange={
                    (event) => onChange('scheduleFoundation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleUnderground ?? undefined}
                  onChange={
                    (event) => onChange('scheduleUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>先行床</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleFloorPrecedence ?? undefined}
                  onChange={
                    (event) => onChange('scheduleFloorPrecedence', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleGround ?? undefined}
                  onChange={
                    (event) => onChange('scheduleGround', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={5}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>予定({workYamadumi.unit5})数（{workYamadumi.unit4}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>基礎</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkFoundation ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkUnderground ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>先行床</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkFloorPrecedence ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkGround ?? undefined}
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        </GridLayout>
      </CardBody>
    </Card>
  )
})
